import React from 'react'
import { Images } from 'components'

export default function LogoAnimatedWhite() {
  return <img src={Images.LogoAnimatedBlack} alt="" width="220" />
}
